module.exports = __webpack_public_path__ + "static/img/A70.171985b9.jpg";